import React from "react";
import { GripVertical } from "lucide-react";
import { getFieldIcon, getColumnSpanClass, getRowSpanClass } from "../utils/field-utils";
import { Field } from "@/services/entity-view.service";
import { DataTypeEnum } from "@/services/entity.service";

interface FieldItemProps {
  field: Field;
}

export function FieldItem({ field }: FieldItemProps) {
  return (
    <div
      className={`flex rotate-2 scale-105 flex-col gap-2 rounded-lg border bg-white p-3 shadow-lg ${getColumnSpanClass(
        field.width,
      )} ${getRowSpanClass(field.height)}`}
    >
      <div className="flex min-h-[24px] items-center gap-2">
        <GripVertical className="h-4 w-4 text-gray-400" />
        {getFieldIcon(field.icon as DataTypeEnum)}
        <span className="flex-1 truncate text-sm font-medium">{field.name}</span>
      </div>
      <div className="flex flex-1 items-center justify-center rounded border border-dashed border-gray-200 text-xs text-gray-500">
        <div className="text-center">
          <div>{field.type}</div>
          <div className="text-xs opacity-75">
            {field.width}×{field.height}
          </div>
        </div>
      </div>
    </div>
  );
}
